<template>
  <div v-wechat-title="title" style="height:100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: `RecoveryIndex`,
    props: {

    },
    data() {
        return {
            title: `术后复苏`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Recovery/Index.vue